import { useEffect, useRef } from 'react';
import { Fireworks as FX } from 'fireworks-js'

export function Fireworks() {
    const fireworks = useRef();

    useEffect(() => {
        if (fireworks.current) {
            fireworks.current.start();
            return;
        }

        // const container = document.querySelector('.fireworks');
        const container = document.querySelector('.fireworks');
        fireworks.current = new FX(container, {
            hue: {
                min: 16,
                max: 64,
            },
            explosion: 6,
            traceSpeed: 3,
        });
        fireworks.current.start();

        setTimeout(() => {
            fireworks.current.stop();
        }, 10000);

        return () => {
            if (fireworks.current) {
                fireworks.current.stop();
            }
        };
    }, []);

    return <div className="fireworks" />;
}
